import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async saveBidderPartner({ commit }, bidderPartner) {
      try {
        return await api.post('/bidders-partners', bidderPartner)
      } catch (error) {
        throw error
      }
    },

    async getBiddersPartners({ commit }, data) {
      try {
        let url = `/bidders-partners?type=${data.type}`

        if (data.active) {
          url += '&active=true'
        }

        const response = await api.get(url)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getBidderPartner({ commit }, bidderPartnerId) {
      try {
        const response = await api.get(`/bidders-partners/${bidderPartnerId}`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateBidderPartner({ commit }, bidderPartner) {
      try {
        return await api.put(
          `/bidders-partners/${bidderPartner.id}`,
          bidderPartner,
        )
      } catch (error) {
        throw error
      }
    },

    async deleteBidderPartner({ commit }, bidderPartnerId) {
      try {
        return await api.delete(`/bidders-partners/${bidderPartnerId}`)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
